import * as Models from '../commonModels';


export class ServiceListModel extends Models.ListBaseModel {
  Items: ServiceModel[];
  NotDefinePriceServiceCommission: number;
}

export class ServiceObjectModel extends Models.ResponseBase {
  Item: ServiceModel;
}

export class ServiceTypeDictionaryListModel extends Models.ListBaseModel {
  Items: ServiceType[];
}


export class ServiceModel {
  constructor(IsSaleService?: boolean) {
    this.ServiceId = null;
    this.Name = null;
    this.ServiceTypeId = null;
    this.ServiceType = null;
    this.IsDefinePrice = null;
    this.IsArticleRelation = null;
    this.IsOnlyForAdmin = null;
    this.IsCarTypeDepend = null;
    this.AddedByUser = null;
    this.AddedByUserId = null;
    this.AddDate = null;
    this.IsActive = null;
    this.Import = null;
    this.AldCode = null;
    this.BussinesLeaseCode = null;
    this.Bfcode = null;
    this.IsSaleService = IsSaleService || null;
  }

  public ServiceId: number;
  public Name: string;
  public ServiceTypeId: number;
  public ServiceType: string;
  public IsDefinePrice: boolean;
  public IsArticleRelation: boolean;
  public IsOnlyForAdmin: boolean;
  public IsCarTypeDepend: boolean;
  public AddedByUser: string;
  public AddedByUserId: number;
  public AddDate: string;
  public IsActive: boolean;
  public Import: number;
  public AldCode: string;
  public BussinesLeaseCode: string;
  public Bfcode: string;
  public IsSaleService: boolean;
  public IsSystemOnly: boolean;
  public IsDepositeContext: boolean;
  public IsDepositeContextOptional: boolean;
  public IsCarContext: boolean;
  public IsMain: boolean;
  public IsNoteRequired: boolean;
  public IsTooShortHeightTreadControl: boolean;
  public NotDefinePriceServiceCommission: number;
  public IsArticleSealed: boolean;  
}


export class ServiceType {
  public ServiceTypeId: number;
  public Name: string;
}

export class CustomerGarageServicePriceModel {
  public ServiceID: number;
  public IsDefinePrice: boolean;
  public ServiceName: string;
  public IsCar: boolean;
  public CarCost: number;
  public IsTruck: boolean;
  public TruckCost: number;
  public IsVan: boolean;
  public VanCost: number;
}

export class CustomerGarageServicePriceSearchModel extends Models.SearchBaseModel {
  public CustomerId: number[];
  public GarageId: number[];
  public IsDefinePrice: boolean;
  public IsActive?: boolean;
}



export class SetCustomerGarageServicePriceModel {
  public CustomerId: number[];
  public GarageId: number[];
  public Prices: CustomerGarageServicePriceModel[];
}

export enum  ServiceTypes {
  Receipt = 6,

  Storage = 4,

  Utylization = 1,

  Return = 5,


}
